module.exports = __webpack_public_path__ + "static/thumbnail-219989fbc5e6ba16c231589e573664cd.png";